import "./App.css";
import Pages from "@/pages/index.jsx";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <>
      <Pages />
      <Toaster />
    </>
  );
}

export default App;
